import { render } from "./ResourceComponent.vue?vue&type=template&id=5827c6b1&scoped=true"
import script from "./ResourceComponent?vue&type=script&lang=js"
export * from "./ResourceComponent?vue&type=script&lang=js"

import "./ResourceComponent.vue?vue&type=style&index=0&id=5827c6b1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5827c6b1"]])

export default __exports__